import axios from "axios";
import { IApiConfig, IImageConfig } from "../config";
import { ImageRole } from "../enums";
import { GalleryImage } from "./Gallery";

export interface GalleryImageWithId extends GalleryImage {
    id: string;
}

export interface IImageProps {
    fileApiConfig: IApiConfig;
    imagesConfig: IImageConfig;
    objectId: string;
}

interface IRelatedImage {
    fileName: string;
    storedFileName: string;
    title?: string;
    description?: string;
}

export const getRelatedImagesData = async (imageProps: IImageProps): Promise<GalleryImageWithId[]> => {
    const relatedImages = await getRelatedImages(imageProps);

    return (
        relatedImages?.length &&
        relatedImages.map(
            (image: IRelatedImage) =>
                ({
                    id: Date.now() + "_" + image.storedFileName,
                    original: getImageUrl(ImageRole.Original, image.storedFileName, imageProps),
                    thumbnail: getImageUrl(ImageRole.Thumbnail, image.storedFileName, imageProps),
                    fullscreen: getImageUrl(ImageRole.Fullscreen, image.storedFileName, imageProps),
                    originalTitle: image.title,
                    thumbnailLabel: image.title,
                    thumbnailTitle: image.title,
                    description: image.description
                } as GalleryImageWithId)
        )
    );
};

export const getRelatedImages = (imageProps: IImageProps): Promise<IRelatedImage[]> =>
    axios
        .get(imageProps.fileApiConfig.url + "GetRelatedImages", {
            params: {
                RelatedObjectId: imageProps.objectId,
                Layer: imageProps.imagesConfig.layerBrowseName,
                FileTable: imageProps.imagesConfig.fileTableName
            }
        })
        .then((resp) => {
            return resp.data;
        });

const getImageUrl = (imageSize: ImageRole, storedFileName: string, imageProps: IImageProps) => {
    const size = imageSize !== ImageRole.Fullscreen ? "&thumbnail=true" : "";
    const imageHeight = () => {
        if (!imageProps) {
            return "";
        }
        const details = imageProps.fileApiConfig.imageDetails;
        switch (imageSize) {
            case ImageRole.Thumbnail:
                return "&height=" + details.thumbnailHeight;
            case ImageRole.Original:
                return "&height=" + details.height;
            default:
                return "";
        }
    };

    return imageProps.fileApiConfig.url + "GetImage?file=" + storedFileName + size + imageHeight();
};
